import { JSONContent } from '@tiptap/react';
import { ArticleFormData } from '../components/AdminArticleForm';

export const mapArticleToFormData = (
  article: any
): ArticleFormData => {
  const translation = article.traducciones?.find((t: any) => String(t.idioma).toUpperCase() === 'ES') || article.traducciones?.[0];

  return {
    title: translation?.titulo ?? '',
    category: String(article.categoriaId ?? ''),
    type: article.grupoArticulo ?? '',
    status: article.estado ?? '',
    resumen: translation?.resumen ?? '',
    content: translation?.contenido ?? {
      type: 'doc',
      content: [],
    },
    existingImageUrl: article.urlImagenPortada ?? '',
    translations: article.traducciones ?? [],
  };
};

export const emptyContent: JSONContent = {
  type: 'doc',
  content: [],
};